const  seriesConnectColor = {
    normal: ["#5470C6", "#FEDF77"],
};
const  seriesCategoryColor = {
    normal: ["#FEC60D", "#3BCDD2", "#A759FF"],
    pale: ["#FEDC6F", "#85E1E3", "#D1A7FF"],
};
module.exports =  {
    seriesConnectColor,
    seriesCategoryColor,
    seriesAppConnectChart: [
        { name: "APP", field: "connectApp", stack: "base", showSum: true, option: { itemStyle: { color: seriesConnectColor.normal[0] } } },
        { name: "WEB", field: "connectWeb", stack: "base", showSum: true, option: { itemStyle: { color: seriesConnectColor.normal[1] } } },
    ],
    seriesAppNewChart: [
        { name: "앱 최초 실행 수", field: "newUser", stack: "base", type: "line", option: { smooth: false, itemStyle: { color: "#C00000" } } },
    ],
    seriesContentChart: [
        { name: "영상", field: "v_play_count", stack: "base", option: { itemStyle: { color: seriesCategoryColor.normal[0] } } },
        { name: "리뷰", field: "r_play_count", stack: "base", option: { itemStyle: { color: seriesCategoryColor.normal[1] } } },
        { name: "스페셜", field: "s_play_count", stack: "base", option: { itemStyle: { color: seriesCategoryColor.normal[2] } } },
    ],
    seriesContentSumChart: [
        { name: "영상", field: "v_play_count_sum", stack: "base", option: { itemStyle: { color: seriesCategoryColor.normal[0] } } },
        { name: "리뷰", field: "r_play_count_sum", stack: "base", option: { itemStyle: { color: seriesCategoryColor.normal[1] } } },
        { name: "스페셜", field: "s_play_count_sum", stack: "base", option: { itemStyle: { color: seriesCategoryColor.normal[2] } } },
    ],
};